module.exports = __webpack_public_path__ + "img/clients.a279e7cb.svg";